import React from "react";
import { useNavigate } from "react-router-dom";

import routes from "constants/routes";
import { tokenUtils } from "utils";
import { PrimaryButton } from "widgets";
import InfinityLearnLogo from "shared/Icons/InfinityLearnLogo";

const APP_TITLE = "Tenant Management Dashboard";

const handleLogout = (navigate) => {
  tokenUtils.deleteToken();
  localStorage.clear();
  navigate(routes.login.root);
};

const AppHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="app-header">
      <div className="app-header-left">
        <div
          className="app-header-logo"
          onClick={() => navigate(routes.tenants.tenants)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              navigate(routes.tenants.tenants);
            }
          }}
        >
          <InfinityLearnLogo />
        </div>
      </div>

      <div className="app-header-center">
        <h1 className="app-header-title">{APP_TITLE}</h1>
      </div>

      <div className="app-header-right">
        <PrimaryButton type="button" onClick={() => handleLogout(navigate)}>
          Logout
        </PrimaryButton>
      </div>
    </header>
  );
};

export default AppHeader;
